import React, { FC } from "react";
import { FormControlLabel } from "@mui/material";

import { Checkbox, FormGroup, Stack, Typography } from "@components/base";

const Checkboxes: FC = () => {
  return (
    <Stack spacing={4}>
      <Typography variant="h2">Checkboxes</Typography>
      <Stack spacing={2}>
        <Typography variant="subtitle2">Default</Typography>
        <FormGroup>
          <FormControlLabel
            control={<Checkbox checked />}
            label="Checkbox checked"
          />
          <FormControlLabel
            control={<Checkbox checked={false} />}
            label="Checkbox"
          />
          <FormControlLabel
            control={<Checkbox checked={false} disabled />}
            label="Disabled"
          />
        </FormGroup>
      </Stack>
      <Stack spacing={2}>
        <Typography variant="subtitle2">Small</Typography>
        <FormGroup>
          <FormControlLabel
            control={<Checkbox checked size="small" />}
            label="Checkbox checked"
          />
          <FormControlLabel
            control={<Checkbox checked={false} size="small" />}
            label="Checkbox"
          />
        </FormGroup>
      </Stack>
      <Stack spacing={2}>
        <Typography variant="subtitle2">Horizontal</Typography>
        <FormGroup row>
          <FormControlLabel
            control={<Checkbox checked />}
            label="Checkbox checked"
          />
          <FormControlLabel
            control={<Checkbox checked={false} />}
            label="Checkbox"
          />
        </FormGroup>
      </Stack>
    </Stack>
  );
};

export default Checkboxes;
